/**
 * Query keys for the Present-a-buyer picker's Suggested tier.
 *
 * 🔴 <b>Rooted on the SAME `["listings"]` prefix as `listingKeys`</b>, so
 * anything that invalidates the catalog also refreshes a ranking derived from
 * it — creating a listing inside the wizard is exactly that case. Keyed on the
 * buyer as well, because the ranking is a fact about a pairing and one buyer's
 * suggestions are worthless to another.
 *
 * <p>Presenting a buyer changes the answer too (a listing already presented to
 * drops out of the suggestions), so the wizard's create invalidates this prefix
 * alongside `buyerSubmissionKeys`. The submission prefix does NOT cover it —
 * different root — and that mismatch is the ordinary shape of a stale-after-save
 * bug this codebase has a gate for.</p>
 */
export const listingMatchKeys = {
  all: ["listings", "matches"] as const,
  forBuyer: (buyerLeadId: string) => [...listingMatchKeys.all, buyerLeadId] as const,
};
